import React from 'react'

export default function ScreenshotWarningModal() {
    return (
        <>
            <div className="screenshot-warning__container warning">On this screen you will be provided with a Report Number and Pin. Please record or screenshot this information to view messages or for future follow up.</div>
        </>
    )
}